__turbopack_context__.v({
  "arrow": "styles-module-scss-module__XzMG3q__arrow",
  "mobileGridSeeMore": "styles-module-scss-module__XzMG3q__mobileGridSeeMore",
  "seeMoreCard": "styles-module-scss-module__XzMG3q__seeMoreCard",
  "seeMoreContent": "styles-module-scss-module__XzMG3q__seeMoreContent",
  "seeMoreDescription": "styles-module-scss-module__XzMG3q__seeMoreDescription",
  "seeMoreText": "styles-module-scss-module__XzMG3q__seeMoreText",
});
